import React from 'react';
import { Link } from "react-router-dom";
import traveTourism from '../assets/images/pngicons/Travel-Tourism.png';
import finance from '../assets/images/pngicons/Finance.png';
import gdstool from '../assets/images/pngicons/GDS-Process-Automation-Tools.png';
import roboticprocess from '../assets/images/pngicons/Robotic-Process-Automation.png';
import healthcare from '../assets/images/pngicons/healthcare.png';
import ndc from '../assets/images/pngicons/ndc.png';
import inventory from '../assets/images/pngicons/inventory.png';
import corporate from '../assets/images/pngicons/corporate-travel.png';
import b2c from '../assets/images/pngicons/b2c.png';

export default function OurProducts() {
  return (
    


<section className='product_section dbl_heading_section'> 

<div className='container  mt-5 mb-5'>

    <div className='row'>
        <div className='col-12'> <div className='hdsub_title'>WHAT WE HAVE</div> </div>
        <div className='col-12 mb-2'> <div className='hd_title'>Our Products</div> </div>
    </div>

<div className='row'>

    <div className='col-lg-4'>

    <div className='products_wrapper'>
    <div className='d-flex align-items-center'>
    <div className='icon_holder'><img src={traveTourism} alt=''></img> </div>
    <div className='title'>Travel Booking Engine (B2B)</div>
    </div>

    <div className='description'>
        <p>We offer comprehensive travel solutions for both B2B (Business-to-Business) and B2C (Business-to-Consumer) markets, as well as tailored corporate travel products designed to meet the unique needs of businesses. Whether you’re a travel agency looking to enhance your offerings, a corporation seeking efficient travel management, or an individual looking for personalized travel experiences, our services cater to all.</p>
    </div>
    <div className='readmore'>
    <Link to='/travel-tourism-b2b'>Read More</Link>

    </div>

    </div>
    
    </div>

    <div className='col-lg-4'>

<div className='products_wrapper'>
<div className='d-flex align-items-center'>
<div className='icon_holder'><img src={b2c} alt=''></img> </div>
<div className='title'>Travel Booking Engine (B2C)</div>
</div>

<div className='description'>
    <p>B2C Travel Portal is online travel booking portal which provides online search and book functionality flights, hotels, Holiday packages, insurance, visa and travel related products to enable global B2C consumers to search and book online. B2C Travel Portal is the key component of a Travel Website. It is a travel portal for retail sales that enables the business to sell more products and increase revenue.
</p>
</div>
<div className='readmore'>
<Link to='/travel-tourism-b2c'>Read More</Link>

</div>

</div>

    </div>

    <div className='col-lg-4'>

<div className='products_wrapper'>
<div className='d-flex align-items-center'>
<div className='icon_holder'><img src={corporate} alt=''></img> </div>
<div className='title'>Travel & Tourism Corporate Booking Portal</div>
</div>

<div className='description'>
    <p>We offer comprehensive travel solutions for both B2B (Business-to-Business) and B2C (Business-to-Consumer) markets, as well as tailored corporate travel products designed to meet the unique needs of businesses. Whether you’re a travel agency looking to enhance your offerings, a corporation seeking efficient travel management, or an individual looking for personalized travel experiences, our services cater to all.</p>
</div>
<div className='readmore'>
<Link to='/travel-tourism-corporate-booking-portal'>Read More</Link>

</div>

</div>

    </div>

    <div className='col-lg-4'>

    <div className='products_wrapper'>
    <div className='d-flex align-items-center'>
    <div className='icon_holder'><img src={gdstool} alt=''></img> </div>
    <div className='title'>GDS Process Automation Tools</div>
    </div>

    <div className='description'>
        <p>We offer advanced Global Distribution System (GDS) Process Automation Tools designed to streamline and optimize travel booking and management workflows for travel agencies, tour operators, and businesses. Our automation tools integrate with major GDS platforms like Amadeus, Sabre, and Galileo, providing seamless access to flight, hotel, car rental, and other travel services, all while reducing manual effort and increasing efficiency.</p>
    </div>
    <div className='readmore'>
    <Link to='/gds-process-automation-tools'>Read More</Link>

    </div>

    </div>

    </div>

    <div className='col-lg-4'>

    <div className='products_wrapper'>
    <div className='d-flex align-items-center'>
    <div className='icon_holder'><img src={roboticprocess} alt=''></img> </div>
    <div className='title'>Robotic Process Automation</div>
    </div>

    <div className='description'>
        <p>Robotic Process Automation (RPA) uses software robots to automate routine, rule-based tasks in your business processes. This technology enables your team to focus on higher-value work, driving innovation and growth. Today, efficiency and accuracy are more critical than ever. Our Robotic Process Automation (RPA) solutions offer a powerful way to streamline your operations, reduce costs, and increase productivity. Whether you’re looking to automate mundane tasks or complex workflows, we have the expertise and technology to make it happen.</p>
    </div>
    <div className='readmore'>
    <Link to='/robotic-process-automation'>Read More</Link>

    </div>

    </div>

    </div>

    <div className='col-lg-4'>

    <div className='products_wrapper'>
    <div className='d-flex align-items-center'>
    <div className='icon_holder'><img src={inventory} alt=''></img> </div>
    <div className='title'>Travel Flight Inventory Module Features</div>
    </div>     

    <div className='description'>
        <p>Our Travel Flight Inventory Module is designed to streamline the management, booking, and distribution of flight inventory for travel agencies, tour operators, and corporate travel planners. The module provides efficient tools to manage flight inventory, enhance customer experience, and maximize revenue.</p>
    </div>
    <div className='readmore'>
    <Link to='/flight-inventory-management-system'>Read More</Link>

    </div>

    </div>

    </div>

    <div className='col-lg-4'>

    <div className='products_wrapper'>
    <div className='d-flex align-items-center'>
    <div className='icon_holder'><img src={finance} alt=''></img> </div>
    <div className='title'>Finance</div>
    </div>

    <div className='description'>
        <p>The Travel Finance System is an integrated, robust solution designed to streamline the financial management of travel agencies, tour operators, and corporate travel departments. It automates and simplifies financial processes, from booking and payment management to invoicing, expense tracking, and reporting, ensuring accurate financial data while reducing administrative workload.</p>
    </div>
    <div className='readmore'>
    <Link to='/travel-tourism-finance'>Read More</Link>

    </div>

    </div>

    </div>

    <div className='col-lg-4'>

    <div className='products_wrapper'>
    <div className='d-flex align-items-center'>
    <div className='icon_holder'><img src={healthcare} alt=''></img> </div>
    <div className='title'>Healthcare Solutions & Hyperautomation</div>
    </div>

    <div className='description'>
        <p>In today’s rapidly evolving healthcare landscape, hyperautomation is revolutionizing how medical providers, healthcare organizations, and pharmaceutical companies manage their operations, deliver services, and improve patient care. We offer a suite of cutting-edge Healthcare and Hyperautomation Products designed to streamline complex workflows, enhance efficiency, and optimize the delivery of healthcare services.</p>
    </div>
    <div className='readmore'>
    <Link to='/healthcare-hyperautomation'>Read More</Link>

    </div>

    </div>

    </div>

    <div className='col-lg-4'>

<div className='products_wrapper'>
<div className='d-flex align-items-center'>
<div className='icon_holder'><img src={ndc} alt=''></img> </div>
<div className='title'>Travel NDC Fares</div>
</div>

<div className='description'>
    <p>New Distribution Capability (NDC) is an advanced technology standard developed by the International Air Transport Association (IATA) that enhances the way airfares and travel products are distributed. NDC aims to provide a more modern, dynamic, and personalized approach to selling airline products, offering consumers better experiences and enabling travel agencies, airlines, and technology providers to deliver tailored services.</p>
</div>
<div className='readmore'>
<Link to='/ndc'>Read More</Link>

</div>

</div>

</div>

</div>

</div>
</section>

  )
}
